// src/pages/Gallery.tsx
import { useState } from 'react';
import ImageModal from '../components/ImageModal';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('Vse');
  const [selectedImage, setSelectedImage] = useState<any>(null);

  const categories = ['Vse', 'Slikarstvo', 'Printi', 'Keramika', 'Tekstil'];

  const artworks = [
    {
      id: 1,
      title: 'Abstraktni pejzaž',
      category: 'Slikarstvo',
      medium: 'Akril na platnu',
      size: '80x60 cm',
      price: 'Na voljo po povpraševanju',
      image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=400&h=300&fit=crop',
      description: 'Abstraktna interpretacija slovenskega pejzaža, navdihnjeno z barvami jeseni.'
    },
    {
      id: 2,
      title: 'Portret v olju',
      category: 'Slikarstvo',
      medium: 'Olje na platnu',
      size: '50x70 cm',
      price: '450€',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop',
      description: 'Ekspresiven portret, ki zajame notranjo lepoto modela.'
    },
    {
      id: 3,
      title: 'Moderna geometrija',
      category: 'Printi',
      medium: 'Digitalni print na papiru',
      size: '30x40 cm',
      price: '45€',
      image: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=400&h=300&fit=crop',
      description: 'Sodobna geometrična kompozicija v minimalistični izvedbi.'
    },
    {
      id: 4,
      title: 'Keramična vaza',
      category: 'Keramika',
      medium: 'Glazirana keramika',
      size: '25x15 cm',
      price: '85€',
      image: 'https://images.unsplash.com/photo-1578749556568-bc2c40e68b61?w=400&h=300&fit=crop',
      description: 'Ročno oblikovana vaza z unikatnim glazurnim vzorcem.'
    },
    {
      id: 5,
      title: 'Umetniška torba',
      category: 'Tekstil',
      medium: 'Platno z ročno poslikavo',
      size: '35x40 cm',
      price: '35€',
      image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=300&fit=crop',
      description: 'Praktična torba z avtorskim motivom, popolna za vsakodnevno uporabo.'
    },
    {
      id: 6,
      title: 'Barvni spekter',
      category: 'Slikarstvo',
      medium: 'Akvarel na papiru',
      size: '40x30 cm',
      price: '180€',
      image: 'https://images.unsplash.com/photo-1536924940846-227afb31e2a5?w=400&h=300&fit=crop',
      description: 'Igriva akvarel kompozicija, ki raziskuje prehode med barvami.'
    },
    {
      id: 7,
      title: 'Teksturni print',
      category: 'Printi',
      medium: 'Giclée print',
      size: '50x70 cm',
      price: '75€',
      image: 'https://images.unsplash.com/photo-1549490349-8643362247b5?w=400&h=300&fit=crop',
      description: 'Visokokakovosten print z izrazitimi teksturami in globino.'
    },
    {
      id: 8,
      title: 'Keramični set',
      category: 'Keramika',
      medium: 'Kamnina',
      size: 'Različne velikosti',
      price: '120€',
      image: 'https://images.unsplash.com/photo-1585828923412-62339c2b0e9c?w=400&h=300&fit=crop',
      description: 'Set keramičnih skled in krožnikov za posebne priložnosti.'
    },
    {
      id: 9,
      title: 'Umetniški blazin',
      category: 'Tekstil',
      medium: 'Bombažno platno',
      size: '40x40 cm',
      price: '28€',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop',
      description: 'Mehak blazin z avtorskim dizajnom za dodatek domačnosti.'
    }
  ];

  const filteredArtworks = selectedCategory === 'Vse' 
    ? artworks 
    : artworks.filter(artwork => artwork.category === selectedCategory);

  const openImageModal = (artwork: any) => {
    setSelectedImage(artwork);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Hero Section */}
        <section className="text-center mb-12">
          <div className="max-w-4xl mx-auto">
            <h1 
              className="text-5xl md:text-7xl font-lora font-bold bg-linear-to-r from-purple-400 via-pink-400 to-purple-600 bg-clip-text text-transparent"
              style={{ 
                lineHeight: 1.2,
                paddingBottom: '0.1em',
                marginBottom: '0.5rem'
              }}
            >
              Galerija
            </h1>
            <p className="text-xl md:text-2xl text-white/80 leading-relaxed">
              Raziskujte mojo zbirko unikatnih umetniških del in najdite popoln kos za vaš prostor
            </p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="mb-12">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-purple-400/30 text-white border-2 border-purple-400'
                    : 'glass-card text-white/80 hover:bg-white/20 hover:text-white'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        {/* Gallery Grid */}
        <section className="mb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArtworks.map((artwork, index) => (
              <div 
                key={artwork.id}
                className="glass-card-hover p-4 group cursor-pointer"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => openImageModal(artwork)}
              >
                <div className="relative overflow-hidden rounded-2xl mb-4">
                  <img
                    src={artwork.image}
                    alt={artwork.title}
                    className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-linear-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="inline-block px-3 py-1 bg-purple-400/80 text-white text-xs rounded-full">
                      Klikni za povečavo
                    </span>
                  </div>
                </div>
                
                <div className="space-y-3">
                  <h3 className="text-lg font-semibold text-white group-hover:text-purple-300 transition-colors">
                    {artwork.title}
                  </h3>
                  <div className="space-y-1">
                    <p className="text-sm text-white/70">{artwork.medium}</p>
                    <p className="text-sm text-white/70">{artwork.size}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <span 
                      className="text-sm font-medium text-yellow-300 bg-yellow-300/20 px-3 py-1 rounded-full"
                      style={{ 
                        lineHeight: 1.2,
                        paddingBottom: 0,
                        marginBottom: 0
                      }}
                    >
                      {artwork.price}
                    </span>
                    <button className="glass-card px-4 py-2 text-sm text-white hover:bg-white/20 transition-colors">
                      Povprašaj
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center">
          <div className="glass-card p-12 rounded-3xl max-w-4xl mx-auto">
            <h2 
              className="text-3xl md:text-4xl font-lora font-bold bg-linear-to-r from-purple-400 via-pink-400 to-purple-600 bg-clip-text text-transparent"
              style={{ 
                lineHeight: 1.2,
                paddingBottom: '0.1em',
                marginBottom: '1.5rem'
              }}
            >
              Videli ste nekaj, kar vas je navdušilo?
            </h2>
            <p className="text-xl text-white/80 mb-8 leading-relaxed">
              Kontaktirajte me za več informacij o nakupu ali naročilu podobnega dela
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="glass-card-hover px-8 py-4 text-lg font-medium text-white">
                Pošlji povpraševanje
              </button>
              <button className="glass-card px-8 py-4 text-lg font-medium text-white hover:bg-white/20 transition-all duration-300 border-2 border-purple-400/50">
                Naroči podobno delo
              </button>
            </div>
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <ImageModal
          isOpen={!!selectedImage}
          onClose={closeImageModal}
          imageSrc={selectedImage.image}
          imageAlt={selectedImage.title}
          title={selectedImage.title}
          description={`${selectedImage.description} • ${selectedImage.medium} • ${selectedImage.size} • ${selectedImage.price}`}
        />
      )}
    </div>
  );
};

export default Gallery;